<template>
  <card-wrapper class="py-8">
    <pie-chart :is-loading="isLoading"
               :aggregate-request-outcomes="sortedOutcomes"
               :total="requestTotal"
               title="Automation Rate"
               :hint="hint"
               :default-chart-data="defaultChartData"
               id="automation-rate-chart"
               class="min-w-64"
    />
  </card-wrapper>
</template>

<script>
import PieChart from '@/components/analytics/charts/PieChart'
import CardWrapper from '@/components/base-components/CardWrapper'
import { CHART_TEXT } from '@/utils/text.constants'
import { GRANULARITY_REQUEST } from '@/utils/filter.constants'
import analyticsFilterModule from '@/store/modules/analytics-filter.module'
import requestOutcomeMapper from '@/utils/request-outcome.mapper'
import analyticsModule from '@/store/modules/analytics.module'

export default {
  name: 'AutomationRatePieChart',

  components: {
    PieChart,
    CardWrapper
  },

  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    requestTotal: {
      type: Number,
      default: 0
    },
    defaultChartData: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    granularity: analyticsFilterModule.getGranularity,
    aggregatedAutomationOutcomes: analyticsModule.getAggregatedAutomationOutcomes,

    sortedOutcomes() {
      return requestOutcomeMapper.sortOutcomes(this.aggregatedAutomationOutcomes, 'automation')
    },

    hint() {
      return GRANULARITY_REQUEST === this.granularity ?
        CHART_TEXT.AUTOMATION_RATE_HINT_REQUEST :
        CHART_TEXT.AUTOMATION_RATE_HINT_CONTACT
    }
  }
}
</script>
